export default function TailoredMatchReview({ match }) {
  if (!match?.criteria?.length) return null;
  return <div className="rounded-lg border border-border bg-card p-4 text-sm space-y-3" data-testid="tailored-match-review">
    <h3 className="font-semibold">Tailored résumé match breakdown</h3>
    {match.source_limitation && <p className="text-amber-500">{match.source_limitation}</p>}
    <p className="text-xs text-muted-foreground">{match.screening_note}</p>
    {match.criteria.map((criterion, index) => <details key={index} className="border-t border-border pt-3" data-testid="match-criterion">
      <summary className="cursor-pointer font-medium">{criterion.requirement} — {criterion.earned_points}/{criterion.weight} points</summary>
      <p className="mt-2"><b>{criterion.status}.</b> {criterion.note}</p>
      <p className="mt-2 text-xs text-muted-foreground"><b>Saved source, line {criterion.source_line}:</b> {criterion.source_excerpt}</p>
      {criterion.evidence.map((evidence, i) => <p key={i} className="mt-2 text-xs text-muted-foreground"><b>{evidence.source} · {evidence.location}:</b> {evidence.quote}</p>)}
      {!criterion.evidence.length && <p className="mt-2 text-xs text-muted-foreground">No supporting evidence supplied for this requirement.</p>}
    </details>)}
  </div>;
}
